import numeral from 'numeral';

export function formatRate(rate) {
    return numeral(rate).format(0, 0);
}
